<template>
	<div class="s2s">
		<div ref="submittingOrder" class="s2s-submitting">
			Placing Your Order
		</div>
		<div id="s2s-live-region" aria-live="assertive"></div>
		<div class="s2s-message">
			Slide To Place Order
		</div>
		<div class="s2s-message-anim"></div>
		<div class="s2s-green"></div>
		<button ref="thumb" class="s2s-thumb"
			aria-label="To buy this item now, drag this button or tap the right arrow key three times for keyboard users."
            @keydown.arrow-right.prevent="keyboardDrag"
            @mousedown="handleDragStart"
            @touchstart="handleDragStart"
		>
			<div ref="icon" class="s2s-icon"></div>
		</button>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				isDragging: false,
				startX: 0,
				offsetX: 0
			}
		},
		mounted() {
			window.addEventListener('mouseup', this.handleDragEnd);
			window.addEventListener('touchend', this.handleDragEnd);
		},
		beforeDestroy() {
			window.removeEventListener('mouseup', this.handleDragEnd);
			window.removeEventListener('touchend', this.handleDragEnd);
		},
		methods: {
			handleDragSubmit() {
				const processingMessage = this.$refs.submittingOrder;
				processingMessage.classList.add('s2s-submitting-active');
				this.$emit('userRequestsSubmit');
			},
			keyboardDrag() {
				var rightKeyTapCount = 0;
				const parentWidth = this.$refs.thumb.parentNode.clientWidth - 50;
				var liveRegion = document.getElementById('s2s-live-region');
				rightKeyTapCount++
				liveRegion.innerHTML = '';
				var plural = 's';

				if (rightKeyTapCount >= 3) {
					this.$refs.thumb.style.left = parentWidth + 'px';
					var newText = document.createTextNode('Submitting Order. Please stay on this page.');
					liveRegion.appendChild(newText);
					this.handleDragSubmit();

				} else {
					if (rightKeyTapCount === 2) {
						plural = '';
					}
					var newText = document.createTextNode('Tap the right arrow ' + (3 - rightKeyTapCount) + ' more time' + plural + ' to buy now.');
					liveRegion.appendChild(newText);
					this.$refs.thumb.style.left = (parentWidth / 3) * rightKeyTapCount + 'px';
				}
			},
			handleDragStart(e) {
				e.preventDefault(); // Prevent default browser behavior for touch events
				this.isDragging = true;
				this.startX = e.clientX || e.touches[0].clientX;
				window.addEventListener('mousemove', this.handleDragMove);
				window.addEventListener('touchmove', this.handleDragMove);
			},
			handleDragMove(e) {
				if (this.isDragging) {
					const clientX = e.clientX || e.touches[0].clientX;
					this.updatePositionRotationAndHeight(clientX);
				}
			},
			handleDragEnd() {
				if (this.isDragging) {
					this.isDragging = false;
					window.removeEventListener('mousemove', this.handleDragMove);
					window.removeEventListener('touchmove', this.handleDragMove);
					const element = this.$refs.thumb;
					const parentWidth = element.parentNode.clientWidth - 50;
					const offsetX = this.offsetX;

					if (offsetX >= parentWidth) {
						// Call the callback function if dragged to the right edge
						this.handleDragSubmit();
					} else {
						// If released before reaching the right edge, reset position, rotation, and height
						this.offsetX = 0;
						element.style.left = this.offsetX + 'px';
						const icon = this.$refs.icon;
						icon.style.transform = 'rotate(-45deg)'; // Set rotation to -45 degrees
						icon.style.height = 10 + 'px';
						icon.style.marginLeft = -5 + 'px';
						icon.style.marginTop = 0 + 'px';
						this.$el.querySelector('.s2s-green').style.opacity = 0;
					}
				}
			},
			updatePositionRotationAndHeight(x) {
				const element = this.$refs.thumb;
				const parentWidth = element.parentNode.clientWidth - 50;
				this.offsetX = x - this.startX;
				if (this.offsetX < 0) this.offsetX = 0; // Prevent dragging outside left edge
				if (this.offsetX > parentWidth) this.offsetX = parentWidth; // Prevent dragging outside right edge

				// Calculate percentage of movement within the draggable range
				const percentage = this.offsetX / parentWidth;

				// Update element's position
				element.style.left = this.offsetX + 'px';

				// Rotate and adjust height of the icon
				const icon = this.$refs.icon;
				icon.style.transform = 'rotate(' + (percentage * 2 - 1) * 45 + 'deg)';
				icon.style.height = 10 + percentage * (16 - 10) + 'px';
				icon.style.marginBottom = 0 + percentage * (5 - 0) + 'px';
				icon.style.marginLeft = -5 + percentage * (2 - -5) + 'px';
				this.$el.querySelector('.s2s-green').style.opacity = 0 + percentage * (1 - 0);
			}
		}
	}
</script>


<style lang="scss" scoped>

  @keyframes fade {
     0% {background-position-x: 0}

     0% {background-position-x: -300px}
   }
   
   @keyframes spin {
     0% {transform: rotate(0deg)}
     100% {transform: rotate(360deg)}
   }

   .s2s {
     background: #434750;
     color: #fff;
     border: 1px solid #ccc;
     border-radius: 50px;
     height: 50px;
     max-height: 50px;
     position: relative;
     width: 300px;
     max-width: 100%;
		 margin: 0 auto;
   }

   .s2s-message {
     background: #434750;
     box-shadow: inset 0 0 20px #00000050;
     border-radius: 50px;
     box-sizing: border-box;
     position: absolute;
     width: 100%;
     height: 100%;
     display: flex;
     align-items: center;
     justify-content: center;
     padding-left: 30px;
     position: absolute;
     right: 0;
     top: 0;
   }

   #s2s-live-region {
     position: absolute;
     height: 1px;
     width: 1px;
     overflow: hidden;
     clip: rect(1px, 1px, 1px, 1px);
     clip-path: inset(50%);
     white-space: nowrap;
   }

   @media (prefers-reduced-motion: no-preference) {
     .s2s-message-anim {
       width: 100%;
       height: 100%;
       border-radius: 50px;
       position: absolute;
       background: linear-gradient(90deg, #43475000 20%, #43475080, #43475000 70%);
       animation: 1s fade infinite linear;
       left: 0;
       top: 0;
     }
   }

   .s2s-green {
     width: 100%;
     height: 100%;
     border-radius: 50px;
     position: absolute;
     background: linear-gradient(90deg, #2c681c, #284d1f);
     left: 0;
     top: 0;
     opacity: 0;
   }

   .s2s-thumb {
     width: calc(50px - 4px);
     height: calc(50px - 4px);
     margin: 2px;
     background: #3a7d19;
     position: absolute;
     outline: none;
     border-radius: 50px;
     outline: none;
     top: 0;
     left: 0;
     border: none;
     display: flex;
     align-items: center;
     justify-content: center;

     &:focus {
       outline: 2px solid #3a7d19;
       outline-offset: 4px;
     }

     &:hover {
       box-shadow: 0 0 10px #3a7d19;
       cursor: grab;
       background: #438f1d;
     }
   }

   .s2s-icon {
     border: 2px solid #fff;
     border-left: 0;
     border-top: 0;
     transform-origin: center center;
     transform: rotate(-45deg);
     margin-left: -5px;
     width: 10px;
     height: 10px;
   }
   
   .s2s-submitting {
     background: #3a7d19;
     color: #fff;
     position: absolute;
     width: 100%;
     border-radius: 50px;
     height: 100%;
     display: flex;
     align-items: center;
     justify-content: center;
     position: absolute;
     right: 0;
     opacity: 0;
     transition: opacity .5s .2s;
     top: 0;
     
     &::before {
       content:'';
       animation: spin 1s infinite;
       width: 1em;
       height: 1em;
       border: 2px dotted #fff;
       border-radius: 30px;
       margin-right: .5em;
     }
   }
   
   .s2s-submitting-active {
     z-index: 10 !important;
     opacity: 1;
   }

   body {
     background: #f5f7fb;
     font-family: sans-serif;
     font-size: 16px;
     display: flex;
     align-items: center;
     justify-content: center;
     min-height: 100dvh;
   }
</style>